module.exports = require('./helpers/bundle-url').getBundleURL('6sKm4') + "tessellation-worker.d50efc29.js";